type CacheEntry<T> = { ts: number; ttl: number; value: T; version?: number }

// Switch to in-memory cache so in-app browsers (social app webviews) don't rely on persistent storage
const memoryCache = new Map<string, CacheEntry<any>>()

export function cacheGet<T>(key: string): CacheEntry<T> | null {
  const obj = memoryCache.get(key) as CacheEntry<T> | undefined
  if (!obj) return null
  const now = Math.floor(Date.now() / 1000)
  if (obj.ttl > 0 && obj.ts + obj.ttl < now) {
    memoryCache.delete(key)
    return null
  }
  return obj
}

export function cacheSet<T>(key: string, value: T, ttlSec: number, version?: number) {
  const entry: CacheEntry<T> = { ts: Math.floor(Date.now() / 1000), ttl: ttlSec, value, version }
  memoryCache.set(key, entry)
}

export function cacheDel(key: string) {
  memoryCache.delete(key)
}

export function cacheKeyForTenant(tenant: string) {
  return `tenant:${tenant}`
}
